import React from 'react';
import { useOneStopHistoryRequestId } from 'domain/shared/oneStop';

export enum RequestStatus {
  NEW = 'New',
  IN_PROGRESS = 'In Progress',
  CLOSED = 'Closed',
}

const ROW_VARIANTS = {
  [RequestStatus.NEW]: {
    backgroundColor: 'background.error',
    borderColor: 'error.main',
  },
  [RequestStatus.IN_PROGRESS]: {
    backgroundColor: 'background.info',
    borderColor: 'info.main',
  },
  [RequestStatus.CLOSED]: {
    backgroundColor: 'background.default',
    borderColor: 'border.default',
  },
} as const;

const OneStopHistoryRowHighlighter = ({ children }: { children: React.ReactElement }) => {
  const activeRequestId = useOneStopHistoryRequestId();

  const getRowProps = (data: any) => {
    const isActive = data.externalId === activeRequestId;
    const variant = ROW_VARIANTS[data.status as RequestStatus];

    return {
      sx: {
        ...(variant && {
          backgroundColor: variant.backgroundColor,
          '& > th, & > td': {
            backgroundColor: variant.backgroundColor,
            borderColor: variant.borderColor,
          },
          '&:hover': {
            backgroundColor: variant.backgroundColor,
            '& > th, & > td': { backgroundColor: variant.backgroundColor },
          },
        }),
        ...(isActive && {
          outline: '2px solid',
          outlineColor: 'info.main',
          '& td:first-of-type, & td:last-of-type': {
            position: 'relative',
            '&::before': {
              content: "''",
              height: 'calc(100% + 1px)',
              width: '2px',
              position: 'absolute',
              top: '-1px',
            },
          },
          '& td:first-of-type::before': {
            borderLeft: '2px solid',
            borderLeftColor: 'info.main',
            left: 0,
          },
          '& td:last-of-type::before': {
            borderRight: '2px solid',
            borderRightColor: 'info.main',
            right: 0,
          },
        }),
      },
    };
  };

  return React.cloneElement(children, { rowProps: getRowProps });
};

export default OneStopHistoryRowHighlighter;
